// Libraries
import {
  Component,
  Input
} from '@angular/core';

// Models
import { REPAIR_ENTRY_STATUSES } from './../models/repair-set.interface';

/**
 * `RepairEntryStatusComponent` implements a view to show the status of a repair entry.
 */
@Component({
  selector: 'she-repair-entry-status',
  template: `<span class="she-status-repair-entry she-status-repair-entry-{{repairEntry?.status}}">{{getStatus()}}</span>`
})
export class RepairEntryStatusComponent {
  /**
   * Current repair entry.
   */
  @Input() repairEntry: any;

  /**
   * Creates a new `RepairEntryStatusComponent` instance.
   */
  constructor() {}

  /**
   * Returns the status of current repair entry.
   * @return Repair status
   */
  public getStatus(): string {
    return this.repairEntry ? REPAIR_ENTRY_STATUSES[this.repairEntry.status] : '';
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/components/repair-entry-status.component.ts